// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3f_a-","infoBtn":"quickbooks_infoBtn__2i_7j","formBox":"quickbooks_formBox__CRWQH","formFooter":"quickbooks_formFooter__jfrVx"};